import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { TweenMax } from 'gsap';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import CommonButton from '@/components/EcoCreditsDay/CommonButton';
import gtm from '@/utils/gtm';
import { signupCookie } from '@/utils/cookies/signupCookie';

const giftBoxname = styles.giftBox;
export default function GiftBox() {
    const { t } = useLang('ecocreditsday.pageTabs.tabA');
    const { t: t2 } = useLang('ecocreditsday');
    const { locale } = useRouter();

    useEffect(() => {
        const scene = new ScrollMagic.Scene({
            triggerElement: `.${giftBoxname}`,
            offset: 200, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 300,
        });
        const tweenA1 = TweenMax.to(`.${giftBoxname} .text-box`, 0.5, { opacity: 1 });
        scene.setTween(tweenA1);
        controllerDay.addScene(scene);

        return () => {
            scene && scene?.destroy();
        };
    }, []);

    const handleClick = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'ecocredits_button',
            type: 'Register',
            list_name: t2(`pageTabs.tab1`),
            button_name: t('giftBox.btn_text'),
        });
        const redirect = ['us', 'ca'].includes(locale as string)
            ? `https://www.ecoflow.com/${locale}/my`
            : `https://www.ecoflow.com/${locale}/${locale === 'jp' ? 'ecocredits' : 'ecocredits-day'}`;
        const url = `https://www.ecoflow.com/${locale}/register?redirect=${redirect}`;
        signupCookie?.({
            sector_name: t('giftBox.title'),
            entry_position: 6,
        });
        window.open(url);
    };

    const renderTitle = () => {
        if (t('giftBox.sub_title_h5')) {
            return <div className="sub-title">{t('giftBox.sub_title_h5')}</div>;
        }

        if (t('giftBox.sub_title')) {
            return <div className="sub-title">{t('giftBox.sub_title')}</div>;
        }
    };
    const renderDesc = () => {
        if (t('giftBox.left_desc_h5')) {
            return t.rich('giftBox.left_desc_h5', { line1: (text: string) => <span className="red-text">{text}</span> });
        }
        if (t('giftBox.left_desc')) {
            return t.rich('giftBox.left_desc', { line1: (text: string) => <span className="red-text">{text}</span> });
        }
        return '';
    };

    return (
        <div className={`${giftBoxname} gift-box`}>
            <div className="text-box">
                {renderTitle()}
                <div className="title">{t('giftBox.title')}</div>
                <div className="desc">{renderDesc()}</div>
                <div className="btn">
                    <CommonButton padding="10px 20px" borderRadius="27px" border="1px" lineHeight="23px" disabledAni onClick={handleClick}>
                        <div className="btn-text">{t('giftBox.btn_text')}</div>
                    </CommonButton>
                </div>
            </div>
        </div>
    );
}
